<template>
    <div class="pcproducts pc-academy-videos">
        <el-backtop target=".pcproducts"></el-backtop>
        <div class="vivideot" v-if="vitohomevid">
            <div class="vividecont">
                <video :src="vivideotcon" autoplay="autoplay" controls></video>
                <div class="el-icon-circle-close" @click="viclosevideo"></div>
            </div>
        </div>
        <div class="pchome-headerss">
            <headers @ChangeEmit="ChangeEmit" ref="head"></headers>
        </div>
        <position-bar :productc_nav="producthea_nav" :positionNav="positionNav">
            <div class="videohea-right">
                <div class="videohea-righttitle">
                    <!-- <div class="producthearight-item" @click="videoclinav(0)" :class="videotopnavind==0?'viotopna':''"> -->
                    <div class="producthearight-item" @click="videoclinav(0)" :style="videotopnavind==0?'color:'+nav_color : ''">
                        {{videonavall}}
                    </div>
                    <!-- <div class="producthearight-item" v-for="(item,index) in videoclassallss" :class="videotopnavind==item.id?'viotopna':''" :key="index" @click="videoclinav(item.id)"> -->
                    <div class="producthearight-item" v-for="(item,index) in videoclassallss" :style="videotopnavind==item.id?'color:'+nav_color : ''" :key="index" @click="videoclinav(item.id)">
                        {{item.name}}
                    </div>
                </div>
                <div class="videohea-righticon" @click="videodwon">
                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/xiala1.svg" />
                </div>
            </div>
        </position-bar>

        <!--		<div class="videohea" :class="producthea_nav?'producthea_nav':''">-->
        <!--			<div class="videohea-left">-->
        <!--				{{vidcenter}}-->
        <!--			</div>-->
        <!--			<div class="videohea-right">-->
        <!--				<div class="videohea-righttitle">-->
        <!--					&lt;!&ndash; <div class="producthearight-item" @click="videoclinav(0)" :class="videotopnavind==0?'viotopna':''"> &ndash;&gt;-->
        <!--					<div class="producthearight-item" @click="videoclinav(0)" :style="videotopnavind==0?'color:'+nav_color : ''">-->
        <!--						{{videonavall}}-->
        <!--					</div>-->
        <!--					&lt;!&ndash; <div class="producthearight-item" v-for="(item,index) in videoclassallss" :class="videotopnavind==item.id?'viotopna':''" :key="index" @click="videoclinav(item.id)"> &ndash;&gt;-->
        <!--					<div class="producthearight-item" v-for="(item,index) in videoclassallss" :style="videotopnavind==item.id?'color:'+nav_color : ''" :key="index" @click="videoclinav(item.id)">-->
        <!--						{{item.name}}-->
        <!--					</div>-->
        <!--				</div>-->
        <!--				<div class="videohea-righticon" @click="videodwon">-->
        <!--					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/xiala1.svg" />-->
        <!--				</div>-->
        <!--			</div>-->
        <!--		</div>-->
        <div style="padding:10px 0;opacity:0" v-if="producthea_nav">
            <div class="videohea-left">
                {{vidcenter}}
            </div>
        </div>
        <div class="linesd"></div>
        <div class="productfoo" v-for="(item,index) in videoclassliststtcontsecz"  :key='index'  :id="'vidscas'+index">
            <div class="productfoo-downs"  @click="vinavra()">
                {{item.title}}
            </div>
            <div class="productfoo-shop">
                <div class="productfoo-item" v-for="(ite,inde) in item.list" :key="inde" >
                    <div class="shop-video"  @mouseleave="video_out(ite)" @mouseenter="video_in(ite)" @click="video_play_click(ite)">
                        <!--						<video :src="ite.video" :id="'video'+ite.id"   muted :style="playing_video_id==ite.id?'opacity:1':'opacity:0'"></video>-->
                        <!--						<img :src="ite.image"  v-if="playing_video_id !== ite.id" class="video_title_image" >-->
                        <!-- <div class="shopvideo-but" @click="vidostot(ite.video)" >@mouseleave="video_out(ite)" @mouseenter="video_in(ite)" @click="video_play_click(ite)"
                            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcvideosimg/pvviplay.png" />
                        </div> -->
<!--                        <iframe v-if="ite.isPlay" :ref="'youVideo_'+ite.id" class="you-video" :src="ite.video " :title="ite.title" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen>-->

<!--                        </iframe>-->

<!--                        <video-player class="video-player vjs-custom-skin vjs-has-started" :style="{opacity:ite.playVideo ? 1 : 0}" style="transition: all 1s linear 0s;"-->
<!--                                      :ref="'videoPlayer'+ite.id"-->
<!--                                      :playsinline="true"-->
<!--                                      :options="ite.option"-->
<!--                        >-->
<!--                        </video-player>-->
                        <img class="play" :src="require('../../assets/common/img/play.png')" alt="">
                        <img  :src="ite.poster" class="video_title_image" :style="{opacity:ite.playVideo ? 0 : 1}" style="transition: all 1s linear 0s;">
                    </div>
<!--                    <div class="shop-icon" @click="downvideo(ite)" >-->
                    <div class="shop-icon"  @click="video_play_click(ite)" >
                        <div class="shopicon-left">
                            {{ite.title}}
                        </div>
<!--                        <div class="shopicon-right">-->
<!--                            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcvideosimg/download.svg" />-->
<!--                        </div>-->
                    </div>
                </div>
            </div>

            <div class="productfoo-more" v-if="item.mess1">
                <div class="more-but" @click="netless(index)" >
                    Up
                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/xiala1.svg" style="transform:scale(1,-1)"/>
                </div>
            </div>

            <div class="productfoo-more" v-else>
                <div class="more-but" @click="netmore(index)" >
                    More
                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/xiala1.svg" />
                </div>
            </div>
        </div>
        <footers ref=is_change ></footers>
    </div>
</template>

<script>
    import 'lib-flexible/flexible.js'
    import {session} from '../../storage/storage.js';
    import headers from '../../common/header.vue'
    import footers from '../../common/footers.vue'
    import positionBar from '../../components/position-bar.vue'
    import utils from '../../api/utils.js'

    export default{
        data(){
            return{
                producthea_nav:false,
                id:'',
                vitohomevid:false,
                videonavnums:5,
                vivideotcon:'',
                videoclassliststtcontsecz:[],
                videonavall:'全部',
                vidcenter:'视频中心',
                // prointrod:'产品介绍',
                casesha:'案例分析',
                networkco:'显示更多',
                networkco_pack:'收起列表',
                navheader:true,
                heshow:false,
                show: false,
                playli:true,
                playri:true,
                videoclassallss:'',
                videoclassliststt:'',
                videotopnavind:0,
                classidd:0,
                options: [{
                    value: '选项1',
                    label: '啄木鸟官网'
                }, {
                    value: '选项2',
                    label: '啄木鸟官网1'
                }, {
                    value: '选项3',
                    label: '啄木鸟官网2'
                }, {
                    value: '选项4',
                    label: '啄木鸟官网3'
                }, {
                    value: '选项5',
                    label: '啄木鸟官网4'
                }],
                optionslang: [{
                    valuelang: '选项1',
                    labellang: 'CN'
                }, {
                    valuelang: '选项2',
                    labellang: 'EN'
                }],
                value: '',
                valuelang: '',
                list_img: [
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:1,is_cover:false},
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:2,is_cover:false},
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:3,is_cover:false},
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:4,is_cover:false},
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:5,is_cover:false},
                    // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:6,is_cover:true},
                    // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:2,is_cover:false},
                    // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:3,is_cover:false},
                    // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:4,is_cover:false},
                ],
                scroll_height:0,
                playing_video_id:0,
                nav_color:session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'#5f5d5d',
                is_query:true,

                playerOptions: null,
                positionNav:[
                    {
                        title:'Home',
                        path:'/pchome',
                    },
                    {
                        title:'Academy',
                        path:'/pccourses',
                    },
                    {
                        title:'Videos',
                        path:'',
                    },
                ],
                isVideoclasslist:false
            }
        },
        components:{
            headers,
            footers,
            positionBar
        },
        created() {
            /* this.value=this.options[0].label
            this.valuelang=this.optionslang[0].labellang */
            // this.getParams()
            this.videoclassall()
            this.videoclasslist()
            this.heshow=true

        },
        watch:{
            '$route': 'getParams'
        },
        mounted() {

            document.addEventListener('scroll',this.handleScroll,false)
            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('scroll', this.handleScroll,false)
            })
            if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                console.log('手机手机21321321')

                this.$router.push({path:'ph-academy-videos',query:{e:this.$route.query.e}})
            }

            sessionStorage.setItem('page',JSON.stringify({name:'pc-academy-videos',data:false}))
        },
        methods: {
            playVideo(item){
                // item.isPlay = true
                // item.video = this.getYouUri(item.video_id)
                // this.$forceUpdate()
            },
            getYouUri(videoId){
                return utils.getYouUri(videoId)
            },
            // onPlayerPlay(e,id){
            // 	console.log('id')
            // 	console.log(id)
            // 	var video = this.$refs['videoPlayer'+id]
            // 	video.player.play()
            // },
            vinavra(e){
                id = document.getElementById(`id${i.product_id}`);

            },
            getDataList(index){
                var _this = this
                var data={
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    mold:'pc',
                    page:this.videoclassliststtcontsecz[index].page.current_page,
                    class_id:this.classidd,
                    type:index + 1
                }
                _this.$api.get_academy_video_list(data).then(res => {
                    res.data.data.forEach(v => {
                        v.option = _this.makePlayerOptions(v)
                        _this.$set(v,'playVideo',false)
                        _this.$set(v,'first',true)
                    })
                    _this.videoclassliststtcontsecz[index].list = _this.videoclassliststtcontsecz[index].list.concat(res.data.data)
                    _this.videoclassliststtcontsecz[index].page.current_page = res.data.current_page
                    _this.videoclassliststtcontsecz[index].page.last_page = res.data.last_page
                    if(_this.videoclassliststtcontsecz[index].page.current_page >=  _this.videoclassliststtcontsecz[index].page.last_page){
                        _this.videoclassliststtcontsecz[index].mess1 = true
                    }
                })
            },
            netmore(index){
                if(this.videoclassliststtcontsecz[index].page.last_page == 1){
                    this.videoclassliststtcontsecz[index].mess1 = this.videoclassliststtcontsecz[index].mess1 ? false : true
                    return
                }
                this.videoclassliststtcontsecz[index].page.current_page ++
                this.getDataList(index)

            },
            netless(index){
                if(this.videoclassliststtcontsecz[index].page.last_page == 1){
                    this.videoclassliststtcontsecz[index].mess1 = this.videoclassliststtcontsecz[index].mess1 ? false : true
                    return
                }
                this.videoclassliststtcontsecz[index].page.current_page = 1
                this.videoclassliststtcontsecz[index].mess1 = false
                this.videoclassliststtcontsecz[index].list = []
                this.getDataList(index)


            },
            downvideo(e){
                this.$utils.handleDownloadUri(e.title,e.video)
            },
            ChangeEmit(){ //子组件传递
                //主动调用子组件
                this.$refs.is_change.get_index_channel_data();
                this.$refs.is_change.pageParam();
                this.getParams()
                this.videoclassall()
                this.videoclasslist()
                this.pageParam() //页面静态参数
            },
            videodwon(){
                if(this.videonavnums==5){
                    this.videonavnums=50
                    this.videoclassall()
                }else{
                    this.videonavnums=5
                    this.videoclassall()
                }


            },
            viclosevideo(){
                this.vitohomevid=false
            },
            vidostot(e){
                // var player = this.$video('video'+index,{});
                // console.log(index)
                // this.play()
                // let player = this.$video(this.$refs.video1)
                // document.getElementsByClassName('video')[1].play()
                this.vitohomevid=true
                this.vivideotcon=e
            },
            videoclinav(e){
                this.videotopnavind=e
                this.classidd=e
                this.isVideoclasslist = false
                this.videoclasslist()
            },
            videoclassall(){
                let data={
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page:1,
                    pageSize:this.videonavnums,
                }
                this.$api.get_video_class_all(data).then((res) => {
                    this.videoclassallss=res.data
                });
            },
            videoclasslist(){
                if(this.isVideoclasslist){
                    return
                }
                this.isVideoclasslist = true
                var data={
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    mold:'pc',
                    page:1,
                    class_id:this.classidd,
                }
                const _this = this
                _this.videoclassliststtcontsecz = []
                Promise.all([new Promise((resolve, reject) => {
                    _this.$api.get_academy_video_list({type:1, ...data}).then(res => {
                        resolve(res)
                    })
                }),new Promise((resolve, reject) => {
                    _this.$api.get_academy_video_list({type:2, ...data}).then(res => {
                        resolve(res)
                    })
                }),new Promise((resolve, reject) => {
                    _this.$api.get_academy_video_list({type:3, ...data}).then(res => {
                        resolve(res)
                    })
                })]).then(res => {
                    res[0].data.data.forEach((v) => {
                        v.option = _this.makePlayerOptions(v)
                        _this.$set(v,'playVideo',false)
                        _this.$set(v,'first',true)
                    })
                    _this.videoclassliststtcontsecz.push({
                        list:res[0].data.data,
                        mess1:false,
                        mess2:8,
                        title:'Demo',
                        page:{
                            current_page:res[0].data.current_page,
                            last_page:res[0].data.last_page,
                        },

                    })
                    res[1].data.data.forEach((v) => {
                        v.option = _this.makePlayerOptions(v)
                        _this.$set(v,'playVideo',false)
                        _this.$set(v,'first',true)
                    })
                    _this.videoclassliststtcontsecz.push({
                        list:res[1].data.data,
                        mess1:false,
                        mess2:8,
                        title:'Case Sharing',
                        page:{
                            current_page:res[1].data.current_page,
                            last_page:res[1].data.last_page,
                        },
                    })
                    res[2].data.data.forEach((v) => {
                        v.option = _this.makePlayerOptions(v)
                        _this.$set(v,'playVideo',false)
                        _this.$set(v,'first',true)
                    })
                    _this.videoclassliststtcontsecz.push({
                        list:res[2].data.data,
                        mess1:false,
                        mess2:8,
                        title:'Product Reviews',
                        page:{
                            current_page:res[2].data.current_page,
                            last_page:res[2].data.last_page,
                        },
                    })
                })
            },
            handleScroll () {
                let scrollTop = document.documentElement.scrollTop ||document.body.scrollTop
                let head_height = this.$refs.head.getHeaderHeight()
                if(scrollTop>head_height){
                    // if(scrollTop>this.scroll_height){
                    this.producthea_nav = true
                    // }else{
                    // 	this.producthea_nav = false
                    // }
                    this.scroll_height = scrollTop
                }else{
                    this.producthea_nav = false
                }
                this.$refs.head.scrollTop_change(scrollTop,'pcelites')
            },
            pageParam(){
                let lang =  session.get("lang");
                if (lang === "cn"){
                    this.vidcenter = "视频中心"
                    this.videonavall="全部"
                    // this.prointrod="产品介绍"
                    this.casesha="案例分析"
                    this.networkco="显示更多"
                    this.prointrod =  [
                        {'vidtitle':'产品介绍'},
                        {'vidtitle':'案例分析'},
                        {'vidtitle':'网络课程'},
                    ]
                }else{
                    this.vidcenter = "VIDEO"
                    this.videonavall="all"
                    // this.prointrod="Product Introduction"
                    this.casesha="Case sharing"
                    this.networkco="Show more"
                    this.prointrod =  [
                        {'vidtitle':'Product Introduction'},
                        {'vidtitle':'Case Sharing'},
                        {'vidtitle':'Webinar'},
                    ]
                }
            },
            hometo(){
                this.$router.push({path: '/pchome'})
            },
            videoto(){
                this.$router.push({path: '/pcvideos'})
            },
            queryto(){
                this.$router.push({path: '/pcquerys'})
            },
            productto(){
                this.$router.push({path: '/pcproduct'})
            },
            elitesto(){
                this.$router.push({path: '/pcelites'})
            },
            contactusto(){
                this.$router.push({path: '/pccontactus'})
            },
            aboutto(){
                this.$router.push({path: '/pcabout'})
            },
            seachto(){
                this.$router.push({path: '/pcseachs'})
            },
            nextimg(){
                let l = this.list_img.length;
                let scroll = document.getElementById('scroll-x');
                let diatance = scroll.scrollWidth - scroll.clientWidth;
                if(this.current_index == 0){
                    this.current_index = l-1;
                    scroll.scrollLeft = diatance;
                }else{
                    this.current_index--;
                    scroll.scrollLeft -= diatance / (l - 1);
                }
            },
            preimg(){
                let l = this.list_img.length;
                let scroll = document.getElementById('scroll-x');
                let diatance = scroll.scrollWidth - scroll.clientWidth;
                if(this.current_index+1 == l){
                    this.current_index = 0;
                    scroll.scrollLeft = 0;
                }else{
                    this.current_index++;
                    scroll.scrollLeft += diatance / (l - 1);
                }
            },
            enter(index){
                this.navheader= true;
            },
            playenterli(){
                this.playli=false
            },

            playenterri(){
                this.playri=false
            },
            playleaveli(){
                this.playli=true
            },
            playleaveri(){
                this.playri=true
            },
            getParams () {
                this.id = this.$route.query.e
                this.$refs.is_change.scrollIntoView('vidscas'+this.$route.query.e)
            },
            video_in(item){
                this.playVideo(item)
                // this.playing_video_id = item.id
                // setTimeout(() => {
                // 	var video = document.getElementById('video'+item.id)
                // 	video.play()
                // }, 10);
                // this.playerOptions = this.makePlayerOptions(item)

                // let ref = 'videoPlayer'+item.id
                // if(item.first){
                //     item.first = false
                //     this.$refs[ref][0].player.src(item.video)
                // }
                // item.playVideo = true
                // this.$refs[ref][0].player.play()

            },
            video_out(item){
                item.isPlay = false
                this.$forceUpdate()
                // let ref = 'videoPlayer'+item.id
                // this.$refs[ref][0].player.src(item.video)

                // this.$refs[ref][0].player.src(item.video)
                // var _this = this , video = document.getElementById('video'+item.id)
                // video.pause()
                // video.currentTime = 0
                // _this.playing_video_id = 0
                // setTimeout(() => {
                // 	_this.playing_video_id = 0
                // }, 10);
            },
            makePlayerOptions(o){
                return  {
                    //播放速度
                    // playbackRates: [0.5, 1.0, 1.5, 2.0],
                    //如果true,浏览器准备好时开始回放。
                    autoplay: false,
                    // 默认情况下将会消除任何音频。
                    muted: true,
                    // 导致视频一结束就重新开始。
                    loop: true,
                    // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    // preload: 'auto',
                    language: 'zh-CN',
                    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    aspectRatio: '16:9',
                    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    fluid: true,
                    sources: [{
                        //类型
                        type: "video/mp4",
                        //url地址
                        src: o.video
                        // src: 'https://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/5fc120f6387702294747604227/f0.mp4'
                    }],
                    //你的封面地址
                    poster: o.poster,
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    // notSupportedMessage: '此视频暂无法播放，请稍后再试',
                }
            },
            video_play_click(item){
                window.open(utils.getYouUrl(item.video_id))
            }
        }
    }
</script>

<style >

    body{
        margin: 0;
        padding: 0;
        background: #fff;
    }
    .pc-academy-videos .pcproducts{
        width: 100%;
        height: 100%;
        position: relative;
        background: #fff;
    }
    .pc-academy-videos .pchome-headerss{
        width: 100%;
        position: relative;
        background-size: 100% 100%;
        padding-top:119px;
        box-sizing: border-box;
    }

    .pc-academy-videos .checse{
        margin-top: 0 !important;
    }
    .pc-academy-videos .product-title{
        color: #fff;
        margin-top: 249px;
        margin-left: 240px;
    }
    .pc-academy-videos .title-hea{
        font-size: 20px;
        font-weight: normal;
        letter-spacing: 1px;
    }
    .pc-academy-videos .title-model{
        margin-top: 15px;
        margin-bottom: 15px;
        font-size: 44px;
        font-weight: normal;
        letter-spacing: 2px;
    }
    .pc-academy-videos .product-but{
        margin-top: 40px;
        font-size: 16px;
        width: 110px;
        height: 46px;
        background: #E31E24;
        border-radius: 23px;
        line-height: 46px;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
    }
    /* .header-navss{
        width: 1400px;
        height: 79px;
        display: flex;
        align-items: center;
        padding: 0 260px;
        position: fixed;
        top: 0;
    } */
    .pc-academy-videos .nav-wit{

    }
    .pc-academy-videos .nav-left{
        width: 100px;
        height: 50px;
    }
    .pc-academy-videos .nav-left img{
        width: 100%;
        height: 100%;
    }
    /* .nav-center-item:hover{
        border-bottom: 2px solid #E31E24;
    } */

    .pc-academy-videos .nav-center-item:first-child{
        margin-left: 0;
    }
    .pc-academy-videos .nav-right{
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        margin-left: 180px;
    }
    .pc-academy-videos .nav-right .search{
        width: 20px;
        height: 20px;
        margin-right: 20px;
        cursor: pointer;
    }
    .pc-academy-videos .nav-right .search img{
        width: 100%;
        height: 100%;
    }
    .pc-academy-videos .nav-right .homename{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        cursor: pointer;
    }
    .pc-academy-videos .nav-right .homename img{
        width: 16px;
        height: 16px;
        margin-left: 4px;
    }
    .pc-academy-videos .nav-right .language{
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .pc-academy-videos .nav-right .language img{
        width: 16px;
        height: 16px;
        margin-left: 6px;
    }

    .pc-academy-videos .bb{
        background: #FAFAFA;
        position: fixed;
        top: 0;
        z-index: 99;
    }
    .pc-academy-videos .aboutitem-hea{
        margin-top: 80px;
        margin-bottom: 40px;
        height: 33px;
        font-size: 24px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 33px;
        letter-spacing: 1px;
    }
    .pc-academy-videos .aboutitem-fooitem{
        margin-bottom: 10px;
    }
    .pc-academy-videos .fooitem-left{
        width: 110px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid #EAEAEA;
        display: flex;
        align-items: center;
        justify-content: center;


        font-size: 16px;
        font-weight: 400;
        color: #FAFAFA;
        margin-right: 20px;
    }
    .pc-academy-videos .fooitem-left img{
        width: 16px;
        height: 16px;
        margin-right: 6px;
    }
    .pc-academy-videos .aboutitem-foosus{
        display: flex;
        margin-bottom: 20px;
    }
    .pc-academy-videos .fooitem-right{
        font-size: 16px;
        font-weight: 400;
        color: #CCCCCC;
    }
    .pc-academy-videos .fooitem-cont{
        margin-top: 25px;
        margin-left: 40px;
    }
    .pc-academy-videos .fooitem-cont:first-child{
        margin-left: 0px;
    }
    .pc-academy-videos .fooite-img{
        display: flex;
    }
    .pc-academy-videos .fooite-img img{
        width: 90px;
        height: 90px;
    }
    .pc-academy-videos .fooite-nam{
        text-align: center;
        margin-top: 20px;
    }
    .pc-academy-videos .right-tit{
        margin-bottom: 5px;
    }
    .pc-academy-videos .homefoot{

        height: 94px;
        background: #272727;
        border-top: 2px solid #666;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .pc-academy-videos .foot-hea{
        height: 22px;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
    }
    .pc-academy-videos .foot-f{
        height: 22px;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
        margin-top: 10px;
        margin-bottom: 20px;
    }
    .pc-academy-videos .videohea{
        width: 1400px;
        /* height: 80px; */
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 260px;
    }
    .pc-academy-videos .videohea-left{
        font-size: 28px;
        color: #5d5f5f;
    }
    .pc-academy-videos .videohea-right{
        display: flex;

    }
    .pc-academy-videos .videohea-righttitle{
        max-width: 800px;
        display: flex;
        font-size: 16px;
        flex-wrap: wrap;
        //margin-left: -24px;
        color: #5d5f5f;
        margin-top: 10px;
      position: relative;
    }
    .pc-academy-videos .producthearight-item{
        margin-bottom: 10px;
        cursor: pointer;
        margin-left: 24px;

    }
    .pc-academy-videos .producthearight-item:first-child{
        //margin-left: 0px;
      position: absolute;
      left: -44px;
    }
    .pc-academy-videos .videohea-righticon{
        width: 20px;
        height: 20px;
        margin-left: 9px;
        display: flex;
        align-items: center;
        margin-top: 10px;
    }
    .pc-academy-videos .videohea-righticon img{
        width: 100%;
        height: 100%;
    }
    .pc-academy-videos .linesd{
        width: 1400px;
        height: 1px;
        background: #EAEAEA;
        margin: 0 auto;
    }
    .pc-academy-videos .productfoo{
        width: 1400px;
        display: flex;
        flex-direction: column;
        padding: 0 260px;

    }
    .pc-academy-videos .productfoo-downs{
        font-size: 28px;
        font-weight: 500;
        color: #5d5f5f;
        margin: 30px 0;
    }

    .pc-academy-videos .productfoo-shop{
        display: flex;
        flex-wrap: wrap;
        margin-left: -40px;
    }
    .pc-academy-videos .productfoo-item{
        width: 320px;
        margin-left: 40px;
        margin-bottom: 40px;
    }
    .pc-academy-videos .shop-video{
        position: relative;
        width: 320px;
        height: 180px;
        display: flex;
        cursor: pointer;
        border-radius: 20px;
        overflow: hidden;
    }
    .pc-academy-videos .shop-video .you-video {

    }



    .pc-academy-videos .shop-video video{
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }
    .pc-academy-videos .shopvideo-but{
        position: absolute;
        top: 70px;
        left: 140px;
        width: 40px;
        height: 40px;
        display: flex;
    }
    .pc-academy-videos .shopvideo-but img{
        width: 100%;
        height: 100%;
    }
    .pc-academy-videos .shop-video .play {
        width: 50px;
        height: 50px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        z-index: 9;
    }
    .pc-academy-videos .video_title_image{
        border-radius: 10px;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }
    .pc-academy-videos .shop-icon{
        width: 320px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 24px;
    }
    .pc-academy-videos .shopicon-left{
        width: 300px;
        font-size: 16px;
        font-weight: 400;
        color: #5d5f5f;
        cursor: pointer;
    }
    .pc-academy-videos .shopicon-right{
        width: 20px;
        height: 20px;
        margin-right: 12px;
        cursor: pointer;
        display: flex;
    }
    .pc-academy-videos .shopicon-right img{
        width: 100%;
        height: 100%;
    }
    .pc-academy-videos .productfoo-more{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 50px;
    }
    .pc-academy-videos .more-but{
        width: 120px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid #CCCCCC;
        font-size: 14px;
        color: #999999;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .pc-academy-videos .more-but img{
        width: 16px;
        height: 16px;
        margin-left: 6px;
    }
    .vjs-big-play-button{
        left:50% !important;
        top: 50% !important;
        margin-top: -1em ;
        margin-left: -1.5em ;
    }
    .viotopna{
        color: #D03E3D;
    }

    .pc-academy-videos .vivideot{
        width: 100vw;
        height: 100vh;
        background: rgba(0,0,0,.32);
        position: fixed;
        top: 0px;
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .pc-academy-videos .vividecont{
        position: relative;
        width: 1200px;
        height: 600px;
    }
    .pc-academy-videos .vividecont video{
        width: 1200px;
        height: 600px;
    }
    .pc-academy-videos .el-icon-circle-close{
        font-size: 40px;
        color: #fff;
        position: absolute;
        top: -20px;
        right: -16px;
        cursor: pointer;
    }
    /* .header-nav{
        width: 1400px;
        height: 79px;
        display: flex;
        align-items: center;
        padding: 0 260px;
        position: fixed;
        top: 0;
    } */
    .nav-wit{

    }
    .pc-academy-videos .nav-left{
        width: 100px;
        height: 50px;
    }
    .pc-academy-videos .nav-left img{
        width: 100%;
        height: 100%;
    }
    /* .nav-center-item:hover{
        border-bottom: 2px solid #E31E24;
    } */

    .pc-academy-videos .nav-center-item:first-child{
        margin-left: 0;
    }
    .pc-academy-videos .nav-right{
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        margin-left: 180px;
    }
    .pc-academy-videos .nav-right .search{
        display: flex;
        align-items: center;
        width: 20px;
        height: 20px;
        margin-right: 20px;
        cursor: pointer;
    }
    .pc-academy-videos .nav-right .search img{
        width: 100%;
        height: 100%;
    }
    .pc-academy-videos .nav-right .homename{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        cursor: pointer;
    }
    .pc-academy-videos .nav-right .homename img{
        width: 16px;
        height: 16px;
        margin-left: 4px;
    }
    .pc-academy-videos .nav-right .language{
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .pc-academy-videos .nav-right .language img{
        width: 16px;
        height: 16px;
        margin-left: 6px;
    }
    .pc-academy-videos .producthea_nav{
        top: 0;
        position: fixed;
        z-index: 9;
        background-color: #fff;
        background: rgba(255,255,255,.72);
        backdrop-filter: saturate(180%) blur(20px);
    }

    .pc-academy-videos .shop-video .video-player {
        width: 100%;
    }
    .pc-academy-videos .shop-video .video-js {
        background-color: #ffffff;
    }
    .pc-academy-videos .shop-video .video-player .vjs-control-bar,
    .pc-academy-videos .shop-video .video-player .vjs-big-play-button{
        display: none;
    }
</style>
